<template>
  <div id="app">
    <!-- 缓存的路由组件 -->
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>

    <!-- 不缓存的路由组件 -->
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
  </div>
</template>

<script>
import { loadLanguage, setHtmlDir } from '@/lang/index.js'

export default {
  methods: {
    // 设置语言（todo - main.js已设置）
    async setLang() {
      // const clientLang = 'ar'
      const clientLang = this.$client.getAppInfoLang()
      await loadLanguage(clientLang)
      setHtmlDir(clientLang)
    },
    // 设置title ico
    setHtmlHead() {
      let name = 'Vava - Live video chat'
      let ico = '/ico/ico-vava.png'

      // echo
      if (this.packageName === 'echo') {
        name = 'Echo - Live video chat'
        ico = '/ico/ico-echo.png'
      }
      // joychat
      if (this.packageName === 'joychat') {
        name = 'Joychat - Live video chat'
        ico = '/ico/ico-joychat.png'
      }
      // joyu
      if (this.packageName === 'joyu') {
        name = 'Joyu - Live video chat'
        ico = '/ico/ico-joyu.png'
      }
      // kiko
      if (this.packageName === 'kiko') {
        name = 'Kiko - Live video chat'
        ico = '/ico/ico-kiko.png'
      }
      // vava
      if (this.packageName === 'vava') {
        name = 'Vava - Live video chat'
        ico = '/ico/ico-vava.png'
      }
      // vibeo
      if (this.packageName === 'vibeo') {
        name = 'Vibeo - Live video chat'
        ico = '/ico/ico-vibeo.png'
      }
      // whonow
      if (this.packageName === 'whonow') {
        name = 'WhoNow - Live video chat'
        ico = '/ico/ico-whonow.png'
      }

      document.getElementsByTagName('title')[0].innerText = name

      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.href = ico
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  },
  mounted() {
    // 设置语言
    this.setLang()

    // 设置title ico
    this.setHtmlHead()
  }
}
</script>

<style lang="less">
.custom-nav-block {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: #ffffff;
}

.van-nav-bar {
  background-color: transparent;
}

.van-hairline--bottom::after {
  border-bottom-width: 0px !important;
}

.van-bar .left-nav,
.van-bar .right-nav {
  width: 24px;
  height: 24px;

  font-size: 17px !important;
  font-family: Inter-Bold, Inter-Regular;
  font-weight: bold;
  color: #333333;
}

.van-bar .left-nav {
  margin-right: 6px;
}

.van-popover__action {
  width: calc(100vw / 2) !important;
  height: auto !important;
  padding: 8px;
}

.van-nav-bar__title {
  color: #fff;
  font-family: F-Medium;
}

.van-nav-bar__left .tit-left {
  font-size: 17px;
  font-family: Inter-Regular;
  font-weight: bold;
  color: #333333;
}

::v-deep input::-webkit-input-placeholder {
  color: #d8d8d8;
}
</style>
